import { takeLatest } from 'redux-saga/effects';
import {
 	// Class Certification
	getTrainingClassCertificationListSuccess,getTrainingClassCertificationListFail,

} from './trainingClassCertificationState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/training/training-class-certifications');
const redirectData = {route:'/console/training-class-certifications', mode: 'list', recordId:0 };
const modelName = 'TrainingClassCertification';
const modelId = 'tcc_id';

function* getTrainingClassCertificationList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload),
		getTrainingClassCertificationListSuccess,
		getTrainingClassCertificationListFail,
		null,
		null,
		LOADING_MSG
	);
}



function* trainingClassCertificationSaga() {
	//Class Certificaiton
	yield takeLatest('trainingClassCertification/getTrainingClassCertificationList', getTrainingClassCertificationList);
}

export default trainingClassCertificationSaga;
